
import { mapGetters } from 'vuex'
import dealCustomizer from '../../../common/mixins/customizer/dealCustomizer'
import redirectWeb from '../../../common/mixins/redirectWeb'
import { checkDealSchedule } from '../../../common/utils/dealSchedule.js'

export default {
  name: 'Deal',
  mixins: [dealCustomizer(), redirectWeb],
  data () {
    return {
      showProductDetails: false,
      redirectTimer: null
    }
  },
  computed: {
    ...mapGetters(['storeInfo', 'activeProduct', 'currentMoment']),
    isDealAvailable () {
      try {
        if (!this.activeProduct || this.activeProduct.product_type !== 'deal') {
          return true
        }
        return !!checkDealSchedule(this.activeProduct, this.storeInfo ? this.storeInfo.schedule : null, null, this.currentMoment)
      } catch (e) {
        return true
      }
    }
  },
  mounted () {
    if (!this.isDealAvailable) {
      this.redirectTimer = setTimeout(() => {
        this.$router.push({ path: '/menu/deals' })
      }, 3500)
    }
  },
  beforeDestroy () {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer)
      this.redirectTimer = null
    }
  },
  head () {
    return {
      title: this.$getPageTitle(this.currentItem ? this.$capitalize(this.currentItem.product_type + ' - ' + this.currentItem.name) : 'dealCustomizer')
    }
  }
}
